import { Injectable } from '@angular/core';
import { QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';
import { VatRateForSaleBaseQuery, VatRateForSaleBaseQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(VatRateForSaleBaseQuery)
@Wrapper(VatRateForSaleBaseQueryHandlerBase)
export class VatRateForSaleBaseQueryHandler {
    public constructor(
        rootContext: RootContext
    ) { }
}
